import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PreguntaSatisfaccionState, selectAll } from './pregunta-satisfaccion.reducer';

export const preguntaSatisfaccionState = createFeatureSelector<PreguntaSatisfaccionState>( "pregunta-satisfaccion" );

export const preguntaSatisfaccionAll = createSelector(
	preguntaSatisfaccionState,
	selectAll
);

export const preguntaSatisfaccionPreguntaReady = createSelector(
	preguntaSatisfaccionState,
	state => state.preguntaReady
);

export const preguntaSatisfaccionEncuestaReady = createSelector(
	preguntaSatisfaccionState,
	state => state.encuestaReady
);

export const preguntaSatisfaccionEncuestaSaved = createSelector(
	preguntaSatisfaccionState,
	state => state.encuestaSaved
);

export const preguntaSatisfaccionEncuestaProps = createSelector(
	preguntaSatisfaccionState,
	state => state.encuestaProps
)